import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

import { useTranslation } from '@crehana/i18n';
import Comments from '@crehana/icons/outline/Comments';
import Download from '@crehana/icons/outline/Download';
import Heart from '@crehana/icons/outline/Heart';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';
import { grayDark } from '@crehana/ui/dist/styles/colors';

type ButtonsProps = {
  onClick(): void;
  downloadNumber: number;
  likes?: number;
  comments?: number;
  loading: boolean;
};

const Buttons: FC<React.PropsWithChildren<ButtonsProps>> = ({
  onClick,
  downloadNumber,
  likes = 0,
  comments = 0,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {likes || comments ? (
        <div className="flex font-subtitle3 text-gray-dark mt-24">
          <p className="mr-32 flex items-center">
            <Heart className="mr-4 fill-current" ignoreColor size={24} />
            <span>{likes}</span>
          </p>
          <p className="flex items-center">
            <Comments size={24} color={grayDark} className="mr-4" />
            <span>{comments}</span>
          </p>
        </div>
      ) : null}

      <div className="flex items-center mt-24 flex-col-reverse sm:flex-row">
        <PrimaryButton
          label={t('RESOURCE_DOWNLOAD_BUTTON')}
          leftIcon={{ component: Download, size: 24 }}
          className="w-full sm:w-auto sm:mr-20"
          onClick={onClick}
          disabled={loading}
        />
        {downloadNumber > 0 ? (
          <p className="font-nun text-14 leading-20 text-gray-dark text-center mb-16 sm:mb-0">
            {`${downloadNumber} ${t('RESOURCE_DOWNLOADS')}`}
          </p>
        ) : null}
      </div>
    </>
  );
};

export default Buttons;
